"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const utils_1 = require("@8base/utils");
const TableSchemaContext_1 = require("./TableSchemaContext");
class TableConsumer extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.renderWithSchemaResponse = ({ tablesList, loading }) => {
            const { id, name, app, children } = this.props;
            let tableSchema;
            if (id) {
                tableSchema = utils_1.tablesListSelectors.getTableById(tablesList, id);
            }
            else if (name) {
                tableSchema = utils_1.tablesListSelectors.getTableByName(tablesList, name, app);
            }
            return loading
                ? children({ tableSchema: tableSchema || undefined, loading })
                : children({ tableSchema: tableSchema || null, loading });
        };
    }
    render() {
        return react_1.default.createElement(TableSchemaContext_1.TableSchemaContext.Consumer, null, this.renderWithSchemaResponse);
    }
}
exports.TableConsumer = TableConsumer;
//# sourceMappingURL=TableConsumer.js.map